import React from 'react';
import classNames from 'classnames/bind';
import CDNImage from '../../utils/CDNImage';

import styles from './Offices.module.scss';

let cx = classNames.bind(styles);

const Offices = () => {
	return (
		<section
			id='office_tour'
			className={cx({ offices: true, ' lg:mt-10 py-10': true })}
		>
			<div className='container mx-auto  flex flex-col justify-start items-center'>
				<h1 className='text-tcn-dark-blue font-Avenir-Black text-3xl lg:text-5xl py-4 text-center lg:text-left'>
					<small className='font-Avenir-Black'>CONOCE</small> <strong className='font-Avenir-Black'>NUESTRAS OFICINAS</strong>
				</h1>
			</div>
			<div className='w-full flex flex-col lg:flex-row'>
				<div className='flex w-3/12'>
					<CDNImage
						className={cx({ bubbles_title: true, 'hidden lg:flex': true })}
						image_name='20200521_IDEAL_tcn-54.png'
						alt='Circulo_derecha'
					/>
				</div>
				<div className='hidden lg:flex w-6/12'>
					<div className='flex w-full'>
						<div className='flex flex-col w-auto h-auto items-center justify-center lg:pl-10'>
							<iframe
								title='video'
								width='650'
								height='350'
								src='https://www.youtube-nocookie.com/embed/G7_jNrMY9vg?showinfo=0&rel=0&autoplay=0&controls=0'
								frameborder='0'
								allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
								allowfullscreen
							></iframe>
						</div>
					</div>
				</div>
				<div className='flex lg:hidden flex-col w-auto h-auto lg:items-center lg:justify-center mx-4 lg:pl-20'>
					<iframe
						width='100%'
						height='200'
						title='video'
						src='https://www.youtube-nocookie.com/embed/G7_jNrMY9vg?showinfo=0&rel=0&autoplay=0&controls=0'
						frameborder='0'
						allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
						allowfullscreen
					></iframe>
				</div>
				<div className='flex flex-col w-3/12 justify-start items-end'>
					<CDNImage
						className={cx({ bubbles_title2: true, 'hidden lg:flex': true })}
						image_name='Circulo_derecha.png'
						alt='Circulo_derecha'
					/>
				</div>
			</div>
		</section>
	);
};

export default Offices;
